import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ForgotPasswordForm } from "@tradersage/shared";
import { auth } from "@/util/firebase";

export const Route = createFileRoute("/_auth/forgot")({
  component: ForgotPasswordPage,
  staticData: {
    title: "Forgot Password",
  },
});

function ForgotPasswordPage() {
  const navigate = useNavigate();

  return (
    <ForgotPasswordForm
      auth={auth}
      onSignInClick={() => navigate({ to: "/signin" })}
      onSignUpClick={() => navigate({ to: "/signup" })}
    />
  );
}
